var __TEMP__ = require('./_baseForRight.js');var baseForRight = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castFunction.js');var castFunction = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keysIn.js');var keysIn = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : baseForRight(object, castFunction(iteratee), keysIn);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = forInRight;
